// MODIFIED
import axios from "../../api/apiClient";
import { domain, token } from "../../components/Security";

const headers = {
  Authorization: `Bearer ${token}`,
  "Content-Type": "application/json",
};

/**
 * SHARED UTILITIES
 */
const postRequest = (url, payload) => axios.post(`${domain}/api/${url}`, payload, { headers });
const putRequest = (url, payload) => axios.put(`${domain}/api/${url}`, payload, { headers });
const getRequest = (url) => axios.get(`${domain}/api/${url}`, { headers });

/**
 * SPECIFIC LOAN IMPLEMENTATIONS
 * Update these individual objects when a specific loan's logic changes.
 */

const SSS_LOAN_STRATEGY = {
  endpoint: "SSSLoan",
  add: async (payload) => {
    console.log({add: payload})
    return await postRequest(`SSSLoan/upsert/${payload.id}`, { // Save into SSSLoans.cs
      employeePersonalInformationId: payload.employeePersonalInformationId,
      totalLoan: payload.totalLoan,
      totalBalance: payload.totalBalance,
      defaultDeduction: payload.defaultDeduction,
      deductionFrequency: payload.deductionFrequency,
      startCutoffPayrollPeriodId: payload.startCutoffPayrollPeriodId,
      endDeductionCutoff: payload.endDeductionCutoff,
      isActive: payload.isActive,
      remarks: payload.remarks
    });
  },
  edit: async (payload) => {
    return await postRequest(`SSSLoan/upsert/${payload.id}`, { // Save into SSSLoans.cs
      sssLoanRequestId: payload.loanRequestId,
      employeePersonalInformationId: payload.employeePersonalInformationId,
      defaultDeduction: payload.defaultDeduction,
      deductionFrequency: payload.deductionFrequency,
      startCutoffPayrollPeriodId: payload.startCutoffPayrollPeriodId,
      endDeductionCutoff: payload.endDeductionCutoff,
      isActive: payload.isActive,
      remarks: payload.remarks
    });
  },
  recalculate: async (payload) => {
    await putRequest(`SSSLoan/recalculate/${payload.id}`, { // update old loan => create new loan request => create new loan log
      employeePersonalInformationId: payload.employeePersonalInformationId,
      sssLoanRequestId: payload.loanRequestId,
      totalLoan: payload.totalLoan,
      totalBalance: payload.totalLoan,
      defaultDeduction: payload.defaultDeduction,
      deductionFrequency: payload.deductionFrequency,
      startCutoffPayrollPeriodId: payload.startCutoffPayrollPeriodId,
      endDeductionCutoff: payload.endDeductionCutoff,
      status: "Completed"
    });
  }
};

const SSS_EMERGENCY_LOAN_STRATEGY = {
  endpoint: "SSSEMERGENCYLoan",
  add: async (payload) => {
    return await postRequest(`SSSEMERGENCYLoan/upsert/${0}`, {
      employeePersonalInformationId: payload.employeePersonalInformationId,
      totalLoan: payload.totalLoan,
      totalBalance: payload.totalBalance,
      defaultDeduction: payload.defaultDeduction,
      deductionFrequency: payload.deductionFrequency,
      startCutoffPayrollPeriodId: payload.startCutoffPayrollPeriodId,
      endDeductionCutoff: payload.endDeductionCutoff,
      isActive: payload.isActive,
      remarks: payload.remarks
    });
  },
  edit: async (payload) => {
    return await postRequest(`SSSEMERGENCYLoan/upsert/${payload.id}`, {
      sssEmergencyLoanRequestId: payload.loanRequestId,
      employeePersonalInformationId: payload.employeePersonalInformationId,
      defaultDeduction: payload.defaultDeduction,
      deductionFrequency: payload.deductionFrequency,
      startCutoffPayrollPeriodId: payload.startCutoffPayrollPeriodId,
      endDeductionCutoff: payload.endDeductionCutoff,
      isActive: payload.isActive,
      remarks: payload.remarks
    });
  },
  recalculate: async (payload) => {
    await putRequest(`SSSEMERGENCYLoan/recalculate/${payload.id}`, {
      employeePersonalInformationId: payload.employeePersonalInformationId,
      sssEmergencyLoanRequestId: payload.loanRequestId,
      totalLoan: payload.totalLoan,
      totalBalance: payload.totalLoan,
      defaultDeduction: payload.defaultDeduction,
      deductionFrequency: payload.deductionFrequency,
      startCutoffPayrollPeriodId: payload.startCutoffPayrollPeriodId,
      endDeductionCutoff: payload.endDeductionCutoff,
      status: "Completed"
    });
  }
};

const SSS_CALAMITY_LOAN_STRATEGY = {
  endpoint: "SSSCalamityLoan",
  add: async (payload) => {
    return await postRequest(`SSSCalamityLoan/upsert/${0}`, {
      employeePersonalInformationId: payload.employeePersonalInformationId,
      totalLoan: payload.totalLoan,
      totalBalance: payload.totalBalance,
      defaultDeduction: payload.defaultDeduction,
      deductionFrequency: payload.deductionFrequency,
      startCutoffPayrollPeriodId: payload.startCutoffPayrollPeriodId,
      endDeductionCutoff: payload.endDeductionCutoff,
      isActive: payload.isActive,
      remarks: payload.remarks
    });
  },
  edit: async (payload) => {
    return await postRequest(`SSSCalamityLoan/upsert/${payload.id}`, {
      sssCalamityLoanRequestId: payload.loanRequestId,
      employeePersonalInformationId: payload.employeePersonalInformationId,
      defaultDeduction: payload.defaultDeduction,
      deductionFrequency: payload.deductionFrequency,
      startCutoffPayrollPeriodId: payload.startCutoffPayrollPeriodId,
      endDeductionCutoff: payload.endDeductionCutoff,
      isActive: payload.isActive,
      remarks: payload.remarks
    });
  },
  recalculate: async (payload) => {
    await putRequest(`SSSCalamityLoan/recalculate/${payload.id}`, {
      employeePersonalInformationId: payload.employeePersonalInformationId,
      sssCalamityLoanRequestId: payload.loanRequestId,
      totalLoan: payload.totalLoan,
      totalBalance: payload.totalLoan,
      defaultDeduction: payload.defaultDeduction,
      deductionFrequency: payload.deductionFrequency,
      startCutoffPayrollPeriodId: payload.startCutoffPayrollPeriodId,
      endDeductionCutoff: payload.endDeductionCutoff,
      status: "Completed"
    });
  }
};

const PAGIBIG_LOAN_STRATEGY = {
  endpoint: "PagibigLoan",
  add: async (payload) => {
    return await postRequest(`PagibigLoan/upsert/${0}`, {
      employeePersonalInformationId: payload.employeePersonalInformationId,
      totalLoan: payload.totalLoan,
      totalBalance: payload.totalBalance,
      defaultDeduction: payload.defaultDeduction,
      deductionFrequency: payload.deductionFrequency,
      startCutoffPayrollPeriodId: payload.startCutoffPayrollPeriodId,
      endDeductionCutoff: payload.endDeductionCutoff,
      isActive: payload.isActive,
      remarks: payload.remarks
    });
  },
  edit: async (payload) => {
    return await postRequest(`PagibigLoan/upsert/${payload.id}`, {
      pagibigLoanRequestId: payload.loanRequestId,
      employeePersonalInformationId: payload.employeePersonalInformationId,
      defaultDeduction: payload.defaultDeduction,
      deductionFrequency: payload.deductionFrequency,
      startCutoffPayrollPeriodId: payload.startCutoffPayrollPeriodId,
      endDeductionCutoff: payload.endDeductionCutoff,
      isActive: payload.isActive,
      remarks: payload.remarks
    });
  },
  recalculate: async (payload) => {
    await putRequest(`PagibigLoan/recalculate/${payload.id}`, {
      employeePersonalInformationId: payload.employeePersonalInformationId,
      pagibigLoanRequestId: payload.loanRequestId,
      totalLoan: payload.totalLoan,
      totalBalance: payload.totalLoan,
      defaultDeduction: payload.defaultDeduction,
      deductionFrequency: payload.deductionFrequency,
      startCutoffPayrollPeriodId: payload.startCutoffPayrollPeriodId,
      endDeductionCutoff: payload.endDeductionCutoff,
      status: "Completed"
    });
  }
};

const PAGIBIG_CALAMITY_LOAN_STRATEGY = {
  endpoint: "PagibigCalamityLoan",
  add: async (payload) => {
    return await postRequest(`PagibigCalamityLoan/upsert/${0}`, {
      employeePersonalInformationId: payload.employeePersonalInformationId,
      totalLoan: payload.totalLoan,
      totalBalance: payload.totalBalance,
      defaultDeduction: payload.defaultDeduction,
      deductionFrequency: payload.deductionFrequency,
      startCutoffPayrollPeriodId: payload.startCutoffPayrollPeriodId,
      endDeductionCutoff: payload.endDeductionCutoff,
      isActive: payload.isActive,
      remarks: payload.remarks
    });
  },
  edit: async (payload) => {
    return await postRequest(`PagibigCalamityLoan/upsert/${payload.id}`, {
      pagibigCalamityLoanRequestId: payload.loanRequestId,
      employeePersonalInformationId: payload.employeePersonalInformationId,
      defaultDeduction: payload.defaultDeduction,
      deductionFrequency: payload.deductionFrequency,
      startCutoffPayrollPeriodId: payload.startCutoffPayrollPeriodId,
      endDeductionCutoff: payload.endDeductionCutoff,
      isActive: payload.isActive,
      remarks: payload.remarks
    });
  },
  recalculate: async (payload) => {
    await putRequest(`PagibigCalamityLoan/recalculate/${payload.id}`, {
      employeePersonalInformationId: payload.employeePersonalInformationId,
      pagibigCalamityLoanRequestId: payload.loanRequestId,
      totalLoan: payload.totalLoan,
      totalBalance: payload.totalLoan,
      defaultDeduction: payload.defaultDeduction,
      deductionFrequency: payload.deductionFrequency,
      startCutoffPayrollPeriodId: payload.startCutoffPayrollPeriodId,
      endDeductionCutoff: payload.endDeductionCutoff,
      status: "Completed"
    });
  }
};

const CASH_ADVANCE_STRATEGY = {
  // endpoint: "CashAdvance",
  // add: async (payload) => {
  //   // Cash Advance usually doesn't have a 2-step request process in many legacy systems
  //   return await postRequest("CashAdvance", payload);
  // },
  // edit: async (payload) => {
  //   return await putRequest(`CashAdvance/${payload.id}`, payload);
  // }
};

/**
 * MAIN SERVICE EXPORT
 */
export const loanTransactionService = {
  /**
   * Data Fetching
   */
  getExistingLoanRequest: async (type, employeePersonalInformationId) => {
    const endpoint = ENDPOINTS_MAP[type];
    return await getRequest(`${endpoint}/request/existing/${employeePersonalInformationId}`);
  },

  getCurrentLoan: async (type, employeePersonalInformationId) => {
    const endpoint = ENDPOINTS_MAP[type];
    const result = await getRequest(`${endpoint}/current-loan/${employeePersonalInformationId}`);

    if (!result.data) {
      throw new Error("No current loan data found.");
    }
    return result.data;
  },

  getEmployeeLoanLogs: async (type, employeePersonalInformationId) => {
    const endpoint = ENDPOINTS_MAP[type];
    return await getRequest(`${endpoint}/loan-logs/${employeePersonalInformationId}`);
  },

  /**
   * Router for Saving
   */
  save: async (type, mode, payload) => {
    const strategy = STRATEGIES[type];
    if (!strategy) throw new Error(`No implementation found for loan type: ${type}`);

    if (mode === "Add") return await strategy.add(payload);
    if (mode === "Edit") return await strategy.edit(payload);
    if (mode === "Recalculate") return await strategy.recalculate(payload);
  }
};

const ENDPOINTS_MAP = {
  SSS_LOAN: "SSSLoan",
  SSS_EMERGENCY_LOAN: "SSSEmergencyLoan",
  SSS_CALAMITY_LOAN: "SSSCalamityLoan",
  PAGIBIG_LOAN: "PagibigLoan",
  PAGIBIG_CALAMITY_LOAN: "PagibigCalamityLoan",
  CASH_ADVANCE: "CashAdvance",
};

const STRATEGIES = {
  SSS_LOAN: SSS_LOAN_STRATEGY,
  SSS_EMERGENCY_LOAN: SSS_EMERGENCY_LOAN_STRATEGY, // Using SSS logic
  SSS_CALAMITY_LOAN: SSS_CALAMITY_LOAN_STRATEGY,  // Using SSS logic
  PAGIBIG_LOAN: PAGIBIG_LOAN_STRATEGY,
  PAGIBIG_CALAMITY_LOAN: PAGIBIG_CALAMITY_LOAN_STRATEGY,
  // CASH_ADVANCE_LOAN: CASH_ADVANCE_STRATEGY,
};